export const GET_PARTNER_COMPANIES = `
  query getPartnerCompanies($activeOnly: Boolean) {
    getPartnerCompanies(activeOnly: $activeOnly) {
      message
      partnerCompanies {
        id
        name
        slug
        description
        email
        phone
        status
        subscription_id
        partners_count
        subscription { id name codeSubcription }
      }
    }
  }
`;

export const GET_PARTNER_COMPANY_BY_ID = `
  query getPartnerCompanyById($id: ID!) {
    getPartnerCompanyById(id: $id) {
      message
      partnerCompany {
        id
        name
        slug
        description
        email
        phone
        status
        subscription_id
        subscription { id name codeSubcription }
        partners {
          id
          firstName
          lastName
          email
          phoneNumber
          user { ci codigo }
          city { id_city name }
        }
      }
    }
  }
`;

export const GET_PARTNERS = `
  query getPartners($partnerCompanyId: ID) {
    getPartners(partnerCompanyId: $partnerCompanyId) {
      message
      partners {
        id
        firstName
        lastName
        email
        phoneNumber
        frontIdCard
        backIdCard
        photo
        status
        partnerCompany { id name }
        user { id ci codigo status }
        city { id_city name }
      }
    }
  }
`;
